import { Component, OnInit, Output, ViewContainerRef } from '@angular/core';
import { AppAuthenticationService } from '../AppServices/app.authentication';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AppSessionStorage } from '../AppServices/app.sessionstorage';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AppHttpService } from '../AppServices/app.httpservices';
import { LoginModel } from 'src/app/Models/Login';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public http: AppHttpService;

  @Output() change;

  userName: string;
  passWord: string;
  showInvalidLoginMessage: boolean;
  showLockedMessage: boolean;
  form: FormGroup;
  submitting = false;
  showRequiredLoginMessage = false;
  routeSub: any;
  container: ViewContainerRef;

  constructor(private storageManager: AppSessionStorage,
    private authService: AppAuthenticationService,
    private formBuilder: FormBuilder,
    private router: Router, private route: ActivatedRoute,
    private vcr: ViewContainerRef
  ) {

    this.container = vcr;
  }

  logIn() {

    this.submitting = true;
    this.showInvalidLoginMessage = false;
    this.showLockedMessage = false;

    if (this.userName.length > 0) {
      const loginViewModel = new LoginModel();
      loginViewModel.UserName = this.userName;
      loginViewModel.Password = this.passWord;
      this.submitting = true;
      this.authService.logOn(loginViewModel).subscribe((result: any) => {
        if (result.token) {
          this.authService.populateToken(result.token);
          this.router.navigate([`/Admin/ProjectList`]);
          this.submitting = false;
        } else {
          this.submitting = false;
          this.showInvalidLoginMessage = true;
          this.showRequiredLoginMessage = false;
        }
      }, error => {
        this.submitting = false;
      });


    } else {
      this.submitting = false;
      this.showInvalidLoginMessage = false;
      this.showRequiredLoginMessage = true;

    }
  }



  ngOnInit() {
    this.userName = '';
    this.passWord = '';
    this.showInvalidLoginMessage = false;



    this.authService.validateToken().subscribe(data => {
      if (data === true) {
        this.router.navigate([`/Admin/ProjectList`], { relativeTo: this.route });

      }
    }, err => {
      this.authService.clearToken();
    });

  }




}
